import styled from 'styled-components';
import sizeStandards from '../../../Style-guide/size-standards';

const EditCourtPageWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px;

  .images-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px 0px;

    @media only screen and (max-width: ${sizeStandards.screen.LG}px) {
      flex-direction: column;
    }

    > div,
    .images-container {
      @media only screen and (max-width: ${sizeStandards.screen.XL}px) {
        margin: 8px;
        height: 250px;
      }
    }
  }

  .submit-btn {
    margin: 20px 0;
    float: right;

    @media only screen and (max-width: ${sizeStandards.screen.MD}px) {
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      float: none;
      font-size: ${sizeStandards.font.XS}px;
    }
  }
`;

export default EditCourtPageWrapper;
